import axios from 'axios';

type I_FetchParams = { url: string; req: any };

export async function fetchAPI({ url, req }: I_FetchParams) {
    try {
        const { data } = await axios.post(url, req);
        return data;
    } catch (ex) {
        console.log(`${url} Exception =>`, ex);
    }
}

export async function getApi(url: string, option?: any) {
    window.abortController && window.abortController.abort();
    const abortController = new AbortController();
    window.abortController = abortController;
    try {
        const { data } = await axios.get(url, {
            headers: {
                method: 'GET',
                // mode: 'cors',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            signal: abortController.signal,
        });
        return data;
    } catch (ex) {
        console.log(`${url} Exception =>`, ex);
        // throw new Error('api is crashed');
    }
}
